module.exports = __webpack_public_path__ + "img/discountStatus1.88167684.svg";